var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-badge badge",class:_vm.cssClass},[_vm._t("default"),(_vm.removable)?_vm._t("remove",function(){return [_c('i',{staticClass:"mdi mdi-close text-small mar-left-2 cursor-pointer",on:{"click":_vm.onRemove}})]},{"remove":_vm.onRemove}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }